import { useState, useMemo, useEffect } from 'react';
import { initIndex } from '../Callbacks/algoliaHelper/searchClient';
import replaceSearchQuerySeparators from '../utils/replaceSearchQuerySeparators';

const { server } = window?.drupalSettings?.sgnaGeolocation?.siteLocale;

const index = initIndex(`${server}_sgna_careers`);

const useJobSearchAutocompleteValues = (searchTerm, debouncedSearchTerm) => {
  const [searchResultsList, setSearchResultsList] = useState({});
  const defaultRequestParams = {
    page: 0,
    hitsPerPage: 5,
    attributesToRetrieve: ['title', 'nid'],
  };

  function search() {
    if (!searchTerm) {
      setSearchResultsList({});
      return;
    }

    index
      .search(replaceSearchQuerySeparators(searchTerm), defaultRequestParams)
      .then((res) => {
        setSearchResultsList(res.hits);
      });
  }
  useEffect(() => {
    if (debouncedSearchTerm) {
      search();
    }
  }, [debouncedSearchTerm]);
  return useMemo(
    () =>
      !searchResultsList.length
        ? []
        : searchResultsList.map((hit) => {
            return {
              id: hit.nid,
              value: (
                <div
                  dangerouslySetInnerHTML={{
                    // eslint-disable-next-line no-underscore-dangle
                    __html: hit._highlightResult.title?.value,
                  }}
                />
              ),
              searchValue: hit.title,
            };
          }),
    [searchResultsList],
  );
};

export default useJobSearchAutocompleteValues;
